import type { TrackingEvent, TrackingPayload } from '~/types/tracking'
import { version } from '~/package.json'

const SHOP_GENDER: 'male' | 'female' | 'other' = 'other'

const useShopEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => {
  const currentShop = useCurrentShop()
  const { currency, shopId, locale } = currentShop.value ?? {}

  return {
    trackShopInit: () =>
      track('shop_init', {
        shop_currency: currency,
        shop_id: shopId,
        shop_gender: SHOP_GENDER,
        shop_version: version,
        locale: locale.replace(/_/g, '-'),
        landing_page: '/',
        referrer: import.meta.client ? window.document.referrer : '',
      }),
  }
}

export default useShopEvents
